const baseUrl = window.location.origin;
const links = {
  baseUrl,
  appStore: {
    iOS: 'https://itunes.apple.com/us/app/acv-auctions-wholesale-handled/id969808943',
    android: 'https://play.google.com/store/apps/details?id=com.acvauctions.acvauctions',
  },
  contact: {
    auctionAccess: {
      email: 'customerservice@auctionsaccess.com',
      phone: '(205) 414-2739',
    },
    phone: {
      url: 'tel:1-800-553-4070',
      text: '1-800-553-4070',
      transportUrl: 'tel:716-796-6976',
      transportText: '716-796-6976',
    },
    salesRep: {
      phone: '1-(800) 553-4070',
      email: 'service@acvauctions.com',
    },
    email: {
      arbitration: 'mailto:arbitration@acvauctions.com',
      support: 'mailto:support@acvauctions.com',
      satisfaction: 'mailto:satisfaction@acvauctions.com',
      titles: 'mailto:titles@acvauctions.com',
      press: 'mailto:press@acvauctions.com',
      help: 'mailto:helpdesk@acvauctions.com',
      bdrteam: 'mailto:dealeronboarding@acvauctions.com',
    },
  },
  ghost: {
    blog: 'https://www.acvauctions.com/blog',
    press: 'https://www.acvauctions.com/news',
  },
  investors: {
    url: 'https://investors.acvauto.com',
  },
  buyingSystem: {
    title: 'S.A.M.',
    url: `${import.meta.env.VITE_BUYING_MATRIX_BASE_URI}identity/account/acv?t=`,
  },
  clearCarAppraisal: {
    title: 'ClearCar',
    url: `${import.meta.env.VITE_CLEARCAR_APPRAISAL_AUTH_URI}`,
  },
  marketingSite: {
    arbitration: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/arbitration`,
      unwindPlanPolicyUrl: `${import.meta.env.VITE_MARKETING_SITE}/legal/purchase-protection-20-terms`,
      text: 'Arbitration',
    },
    about: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/about`,
      text: 'About',
    },
    blog: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/blog`,
      text: 'Blog',
    },
    careers: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/careers`,
      text: 'Work at ACV',
      smallText: 'Careers',
    },
    contact: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/contact`,
      text: 'Contact',
    },
    dealerForms: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/dealer-forms`,
      text: 'Dealer Forms',
    },
    features: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/features`,
      text: 'Features',
    },
    leadership: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/leadership`,
      text: 'Leadership',
    },
    legal: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/legal`,
      text: 'Legal',
    },
    marketReport: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/acv-market-report`,
      text: 'Market Report',
    },
    news: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/news`,
      text: 'News',
    },
    pricing: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/pricing`,
      text: 'Pricing',
    },
    privacy: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/privacy-policy`,
      text: 'Privacy Policy / Notice at Collection',
    },
    press: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/news`,
      text: 'Press',
    },
    sell: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/sell-on-acv`,
      text: 'Become a Seller',
      smallText: 'Sell',
    },
    smsPolicy: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/smspolicy`,
      text: 'Text message Policy',
    },
    support: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/support`,
      text: 'Support',
    },
    supportCenter: {
      url: 'https://www.acvauctions.com/support-center',
      text: 'Support Center',
    },
    testimonials: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/testimonials`,
      text: 'Dealer Experiences',
      smallText: 'Testimonials',
    },
    titleHubFaqs: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/title-hub-faqs`,
      text: 'Virtual Titles FAQ',
    },
    feeSchedule: {
      url: '/myacv/fee-schedule',
      text: 'Fee Schedule',
    },
    guaranteedSaleTerms: {
      url: `${import.meta.env.VITE_MARKETING_SITE}/legal/guaranteed-sale-terms`,
      text: 'Terms of Service',
    },
  },
  social: {
    facebook: 'https://www.facebook.com/acvauctions/',
    linkedin: 'https://www.linkedin.com/company/acv-auctions',
    twitter: 'https://twitter.com/ACVAuctions',
    instagram: 'https://www.instagram.com/acvauctions/',
  },
  transportationHub: {
    supportContactPhoneNumber: '716-431-3800',
    quotingContactPhoneNumber: '716-463-5342',
  },
  capitalHub: {
    supportContactPhoneNumber: '716-235-3883',
  },
};

export default links;
